import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";
import {composePGOptions} from "../../../blink-sdk/CreatePGDefaultOptions";
import {MerchantSDKSettingsStore} from "./MerchantSDKSettingsStore";
import {MerchantPGStore} from "./MerchantPGStore";
import {isPlainObject} from "../../../stem-core/src/base/Utils";
import {loadVersionedObjectFromResponse} from "../misc/StoreUtils";


export const MerchantUserJourneyType = {
    DEFAULT: "default",
    AB_TEST: "abTest"
};

class MerchantUserJourney extends StoreObject {
    @field("Merchant") merchant;

    @field("MerchantSDKSettings") settingsVersion;
    @field("MerchantUserJourney") versionParent;

    @field(String) name;
    @field options; // JSON
    @field dashboardOptions;

    @field(Date) createdAt;
    @field(Date) lastEditedAt;

    getActions() {
        const actionOption = this.options?.action ?? [];
        return Array.isArray(actionOption) ? actionOption : [actionOption];
    }

    usesMerchantPG(merchantPG) {
        for (const action of this.getActions()) {
            if (action.pgId && action.pgId == merchantPG.id || action.pgId == merchantPG.alias) {
                return true;
            }
        }
        return false;
    }

    getCreatePGAction() {
        return this.getActions().find(action => action.type === "createPG");
    }

    getCreatePGContext() {
        const createPGAction = this.getCreatePGAction();
        const merchantPG = MerchantPGStore.find(pg => pg.alias == createPGAction?.pgId || pg.id == createPGAction?.pgId);
        return composePGOptions({
                ...(createPGAction || {}),
                type: createPGAction?.panelType,
                journeyId: this.id,
                journeyAlias: this.alias,
            },
            this.settingsVersion?.defaultPgOptions,
            merchantPG?.options,
            merchantPG?.id,
        ).context;
    }

    getABTestableContext() {
        let journeyContexts = this.options.context || {};
        journeyContexts = Array.isArray(journeyContexts) ? journeyContexts : [journeyContexts];
        return Object.assign({}, this.getCreatePGContext(), ...journeyContexts.filter(context => isPlainObject(context)));
    }

    toString() {
        return this.name;
    }

    get type() {
        return this.dashboardOptions.type || MerchantUserJourneyType.DEFAULT;
    }
}

export async function apiCreateMerchantUserJourney(data) {
    const response = await apiClient.post("merchant/create_user_journey/", data);
    return loadVersionedObjectFromResponse(MerchantUserJourneyStore, response, null);
}

export async function apiUpdateMerchantUserJourney(data) {
    const response = await apiClient.post("merchant/update_user_journey/", data);
    return loadVersionedObjectFromResponse(MerchantUserJourneyStore, response, data.merchantUserJourneyId);
}

export async function apiDeleteMerchantUserJourney(merchantUserJourneyId) {
    return apiClient.post("merchant/delete_user_journey/", {merchantUserJourneyId});
}

export const MerchantUserJourneyStore = MakeStore("MerchantUserJourney", MerchantUserJourney, {
    dependencies: ["Merchant", "MerchantSDKSettings", "MerchantPG"],
});
